import type { FirebirdEvent } from './types';

type Listener = (...args: unknown[]) => void;

const listeners = new Map<FirebirdEvent, Set<Listener>>();

export function on(event: FirebirdEvent, fn: Listener): void {
  if (!listeners.has(event)) {
    listeners.set(event, new Set());
  }
  listeners.get(event)!.add(fn);
}

export function off(event: FirebirdEvent, fn: Listener): void {
  listeners.get(event)?.delete(fn);
}

export function emit(event: FirebirdEvent, ...args: unknown[]): void {
  listeners.get(event)?.forEach((fn) => {
    try {
      fn(...args);
    } catch (err) {
      console.error(`[FirebirdSDK] Event handler error (${event}):`, err);
    }
  });
}
